import { render } from "./LoadingAnimation.vue?vue&type=template&id=a5df7b44&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=a5df7b44&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5df7b44"

export default script